import { UnauthorizeImage } from "../../assets/images";
import { ContentArea } from "../../components/commons";
import "./Unauthorize.scss";
import { useHistory } from "react-router-dom";

const Unauthorize = () => {
  const history = useHistory();
  return (
    <ContentArea>
      <div className="d-flex justify-content-center align-items-center flex-column">
        <img src={UnauthorizeImage} alt="" />
        <span className="mt-4 mb-3 unauthorize-title">
          You're not authorized to see this page.
        </span>
        <span className="unauthorize-sub-text">
          If you want to access this page then please contact us on{" "}
          <span className="text-danger">info@stco.co.in.</span>
        </span>
        <div>
          <span
            onClick={() => history.push("/")}
            className="btn btn-primary btn-err mt-3"
          >
            Go To Home
          </span>
        </div>
      </div>
    </ContentArea>
  );
};

export default Unauthorize;
